import { getEpicDashboardData, getDashboardV2  } from "../api/epicApi";
import * as types from "../constants/actionTypes";
import { call, put, select, takeLatest } from "redux-saga/effects";
import Cookies from "cookies-js";
import { getDomain } from "../helpers/Tools";
import { logAPI } from "../api/andyliticsApi";

export default function* dashboardSaga() {
    yield takeLatest([types.LOAD_DASHBOARD_START], handleDashStart);
    yield takeLatest([types.USER_AUTHENTICATE_SUCCESS], handleUserAuthenticateSuccess);
    yield takeLatest(types.SWITCH_USER_SAGA, handleUserSwitch);
}

function* handleDashStart(payload) {
    const start = new Date();
    try {
        //debugger;
        yield handleCommonResponse(payload);
        logAPI("Saga.Dashboard.Get", start, null);
    }
    catch (err) {
        console.error(err);
        logAPI("Saga.Dashboard.Get.Failure", start, null, err);
        //debugger;
        // Microsoft Edge throws TypeMismatchError when fetch returns 401
        if (err.status === 401 || err.message === 'TypeMismatchError') {
            console.log("VERIFY_LOGIN");
            yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
        }
        else {
            yield put({ type: types.AJAX_CALL_ERROR, error: err });
            yield put({ type: types.LOAD_DASHBOARD_ERROR, error: err });
        }
        if (payload.callback) {
            payload.callback(null);
        }
    }
}

function* handleUserAuthenticateSuccess(payload) {
    try {
        yield handleCommonResponse(payload);
        if (Cookies.get("BSWPROXY") === null) {
            Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
        }
    }
    catch (err) {
        console.error(err);
    }
}

function* handleUserSwitch(payload) {
    try {
        const currentUser = payload.user;
        try {
            if (currentUser) {
                const sDomain = getDomain();
                console.log('dashboadrdSaga: setting cookie BSWPROXY... old:', Cookies.get('BSWPROXY'), 'new:', currentUser.relationshipId);
                yield put({ type: types.COOKIE_BSWPROXY_START });
                if (currentUser.relationshipId) {
                    Cookies.set('BSWPROXY', currentUser.relationshipId, { path: '/', domain: sDomain });
                }
                else {
                    Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
                }
                yield put({ type: types.COOKIE_BSWPROXY_SUCCESS });
            }
        }
        catch (E) {
            console.error(e);
        }

        yield handleCommonResponse(payload);

        // Forward it on
        payload.type = types.SWITCH_USER_REDUCER;
        yield put(payload);

    }
    catch (err) {
        console.error(err);
    }
}

function* handleCommonResponse(payload) {
    try {
        const domain = yield select((state) => state.domain);
        const header = yield select(state => state.header);
        const currentUser = payload && payload.user ? payload.user : null;
        const externalId = currentUser ? currentUser.externalId : domain.cu && domain.cu.ei ? domain.cu.ei : null;
        if (domain && domain.un && domain.hm) {
            let response = null;
            // the check here fixes bug# 38507; the issue happens when we:
            // switch user from myChartUser1 to pharmacyUser1, and then to myChartUser2,
            // dashboard was loaded  twice - 1st time for myChartUser2, and 2nd time for myChartUser1 (which is avoided by the check here)
            if (payload.type !== 'LOAD_DASHBOARD_START' || !header.switchingProxyUser) {
                response = yield call(getEpicDashboardData, domain.un, domain.t, externalId);
                yield put({ type: types.LOAD_DASHBOARD_SUCCESS, dashBoardData: response, isWaiting: false });

                // dashboard v2 has video visit appointment info
                if (window.serverData.data.ambulatoryVideoVisitEnabled === true) {
                    let responsev2 = yield call(getDashboardV2, domain.t);
                    yield put({ type: types.LOAD_DASHBOARD_V2_SUCCESS, dashBoardDataV2: responsev2 });
                }
            }

            if (payload.callback) {
                payload.callback(response);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
}